<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<crucible-dialog
  dialogTitle="Copying Scenario Events to ..."
  submitLabel="Copy"
  [submitDisabled]="selectedMselId === ''"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.mselList) {
    <div crucibleDialogContent>
      <div class="scenario-event-copy-dialog">
        <h4>Please select the destination MSEL.</h4>
        <mat-radio-group [(ngModel)]="selectedMselId">
          @for (msel of data.mselList; track msel.id) {
            <mat-radio-button [value]="msel.id">
              &nbsp;&nbsp;{{ msel.name }}
            </mat-radio-button>
            }<br />
          </mat-radio-group>
        </div>
      </div>
    }
</crucible-dialog>
